/* eslint-disable no-return-assign */
/* eslint-disable consistent-return */
/* eslint-disable no-case-declarations */
/* eslint-disable prefer-destructuring */
import { message } from 'antd';
import Auth0Lock from 'auth0-lock';
import axios, { all } from 'axios';
/* import * as crypto from 'crypto-js'; */
import moment from 'moment';
import notification from '@iso/components/Feedback/Notification';
import Auth0Config from '@iso/config/auth0.config';
import firebase from '@iso/lib/firebase/firebase';
import history from '@iso/lib/helpers/history';
import { buildQueryParams } from '../../Utils';

const metadata = 'https://api-auth.icancha.com/metadata';

const dummyClassActivities = [
    {
        idactividad: 10001,
        nombre: 'Yoga',
        clasificaciones: [
            { idclasificacion: 20001, nombre: 'Salón grupal' },
            { idclasificacion: 20002, nombre: 'Espacio bienestar' }
        ]
    },
    {
        idactividad: 10002,
        nombre: 'Spinning',
        clasificaciones: [
            { idclasificacion: 20003, nombre: 'Salón indoor' },
            { idclasificacion: 20004, nombre: 'Zona cardio' }
        ]
    },
    {
        idactividad: 10003,
        nombre: 'Baile',
        clasificaciones: [
            { idclasificacion: 20005, nombre: 'Salón de danza' },
            { idclasificacion: 20006, nombre: 'Zona múltiple' }
        ]
    }
];

class Backend {
    static instance;
    static lock;
    constructor() {
        console.info('Backend -> Started');
        this.baseURL = `${process.env.REACT_APP_URL}/centros`;
        this.authURL = `${process.env.REACT_APP_URL}/authentication`;
        this.utilitiesURL = `${process.env.REACT_APP_URL}/utilities`;
        this.ready = false;
        this.firebase = firebase;
        this.idToken = '';
        this.accessToken = '';
        this.headers = { Authorization: `Bearer ${this.idToken}` };
        this.actualUserUID = '';
        this.userData = {};
        // Instantiate Lock
        this.lock = new Auth0Lock(Auth0Config.clientID, Auth0Config.domain, Auth0Config.options);
        
        // Register Auth0 Lock event listeners immediately to catch redirect URL hash on load
        this.lock.on('authenticated', this.setSession);
        this.lock.on('authorization_error', error => {
            console.error({ authorization_error: error });
            notification.error({ 
                message: '¡Tu sesión ha expirado!', 
                description: 'La sesión de autenticación ha expirado, serás redirigido al login para que ingreses tus credenciales' 
            });
            setTimeout(() => this.logout(), 1000);
        });

        this.initializeData();
    }

    static getInstance() {
        if (!Backend.instance) {
            return (Backend.instance = new Backend());
        }
        console.log({ backend: this.instance });
        return Backend.instance;
    }

    /** Funciones para Auth0 */
    login = () => {
        if (!this.lock) {
            return;
        }
        this.lock.show();
    };

    /** Maneja la autenticación */
    handleAuthentication = () => {
        // En este flujo, el hash del URL se procesa automáticamente al instanciar Lock.
        // Los listeners ya están registrados en el constructor para evitar perder el evento.
        console.info('handleAuthentication -> Waiting for Auth0 Lock to parse redirect URL hash.');

    };

    /** Inicializa la sesión luego de verificar el estado de autenticado */
    setSession = authResult => {
        const userMetadata = authResult.idTokenPayload[metadata];
        if (!userMetadata) {
            return this.logout();
        }
        const roleid = userMetadata.roleid;
        switch (roleid) {
            case 1:
                break;
            case 2:
                break;
            case 3:
                break;
            default:
                return this.logout();
        }
        // Setea el tiempo en el que el token expirará
        // const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('expires_at', authResult.expiresIn);
        // Todo el flujo de login ocurrio satisfactoriamente se redirige al dashboard
        history.replace('/dashboard');
    };

    /** Realiza un logout y limpia todas las variables almacenadas */
    logout = () => {
        console.log('se ejecuto logout');
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        document.cookie = '_sso.ic=placeholder; max-age=-1';
        document.cookie = 'sso.ic_=placeholder; max-age=-1';
        // Se limpió toda la data, se redirige al login
        history.replace('/');
        this.lock.logout({
            returnTo: process.env.REACT_APP_REDIRECT
        });
    };

    changeUserPassword = async newPassword => {
        try {
            const destination = `${this.authURL}/usuarios/${this.actualUserUID}/actions/changepassword`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { password: newPassword } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1002:
                    message.info({ content: respuesta });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ changeUserPassword: error });
        }
    };

    /** Funciones para el Backend */
    /** Inicializa los datos requeridos para interactuar con el backend */
    initializeData = () => {
        this.lock.checkSession({}, (error, authResult) => {
            const { href } = window.location;
            if (error) {
                // Plan de contingencia (fallback) para localhost/desarrollo debido al bloqueo de cookies de terceros
                const localIdToken = localStorage.getItem('id_token');
                const localAccessToken = localStorage.getItem('access_token');
                if (localIdToken && localAccessToken) {
                    if (process.env.NODE_ENV !== 'production') {
                        console.warn('checkSession falló en localhost/desarrollo. Intentando fallback con tokens locales:', error);
                    }
                    this.accessToken = localAccessToken;
                    this.idToken = localIdToken;
                    this.headers = { Authorization: `Bearer ${this.idToken}` };
                    
                    let sub = '';
                    try {
                        const payload = JSON.parse(atob(localIdToken.split('.')[1]));
                        sub = payload.sub;
                    } catch (e) {
                        console.warn('No se pudo decodificar sub del localIdToken:', e);
                    }
                    this.actualUserUID = sub;

                    axios({ method: 'GET', url: this.baseURL, headers: this.headers })
                        .then(connection => {
                            const {
                                data: { admindata }
                            } = connection;
                            this.userData = admindata;
                            this.ready = true;
                            if (process.env.NODE_ENV !== 'production') {
                                console.log('Sesión inicializada exitosamente usando fallback de localStorage.');
                            }
                        })
                        .catch(axiosError => {
                            console.error('El fallback de localStorage falló al llamar a la API:', axiosError);
                            const inDashboard = href.includes('dashboard');
                            if (inDashboard) {
                                message.error({ content: 'No hemos podido validar tu sesión, serás redirigido al login para que vuelvas a introducir tus credenciales' });
                                setTimeout(() => this.logout(), 1000);
                            }
                        });
                    return;
                }
                if (error.code === 'login_required') {
                    const inDashboard = href.includes('dashboard');
                    if (inDashboard) {
                        message.error({ content: 'No hemos podido validar tu sesión, serás redirigido al login para que vuelvas a introducir tus credenciales' });
                        setTimeout(() => this.logout(), 1000);
                    }
                }
                if (process.env.NODE_ENV !== 'production') {
                    console.log({ error });
                }
            } else {
                const {
                    idToken,
                    idTokenPayload: { sub },
                    accessToken
                } = authResult;
                this.accessToken = accessToken;
                this.idToken = idToken;
                if (process.env.NODE_ENV !== 'production') {
                    console.log({ idToken, authResult });
                    console.log({ authResult });
                }
                this.actualUserUID = sub;
                this.headers = { Authorization: `Bearer ${this.idToken}` };
                const axiosRequest = axios({ method: 'GET', url: this.baseURL, headers: this.headers });
                axiosRequest
                    .then(connection => {
                        const {
                            data: { admindata, cod, respuesta }
                        } = connection;
                        this.userData = admindata;
                        // console.log({ admindata });
                        this.ready = true;
                        //    console.log({ cod, respuesta, admindata });
                    })
                    .catch(axiosError => {
                        const data = axiosError?.response?.data;
                        const status = axiosError?.response?.status;
                        if (status === 401) {
                            message.error(data?.respuesta);
                            setTimeout(() => {
                                this.logout();
                            }, 1000);
                        } else {
                            notification.error({ message: 'Hay inconvenientes con la conexión', description: `Si deseas información adicional contactanos e indicanos este código: ${data?.cod || '503'}` });
                        }
                    });
            }
        });
    };

    getCentroId = () => {
        const rol = this.userData.profile.idadminrol;
        switch (rol) {
            case 2:
                return this.userData.centros[0].idcentro;
            default:
                return this.userData.sedeFrom;
        }
    };

    getCountryISO = () => {
        console.count('getCountryISO');
        return this.userData.countryISO;
    };

    /** Métodos para centro deportivo */

    getCentroInfo = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}`;
            // message.loading({ content: 'Cargando información del centro deportivo...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta, key: 'process' });
                    return { cod };
                default:
                    // message.success({ content: respuesta, key: 'process', duration: 2 });
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getCentroInfo: error });
        }
    };
    getValueFacture = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/ic-invoices/current-week`;
            // message.loading({ content: 'Cargando información del centro deportivo...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });

            return connection;
        } catch (error) {
            console.log({ getCentroInfo: error });
        }
    };

    updateCentroInfo = async (nombre, sitioweb, idciudad, idpais, descripcion, logo, correo) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { nombre, sitioweb, idciudad, idpais, descripcion, logo, correo } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ updateCentroInfo: error });
        }
    };

    getAllSedes = async (search) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/sedes`;
            if (search) {
                destination = `${this.baseURL}/${centroId}/sedes?search=${search}`;
            }
            // message.loading({ content: 'Obteniendo listado de sedes...', key: 'processSede' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta, key: 'processSede' });
                    return { cod };
                default:
                    // message.success({ content: respuesta, key: 'processSede', duration: 2 });
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getAllSedes: error });
        }
    };

    createAdministrator = async ({ apellido, correo, password, sedes, nombre }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/administrators`;

            //    console.log({ apellido, correo, password, sedes, nombre });
            const connection = await axios({
                method: 'POST',
                url: destination,
                headers: this.headers,
                data: {
                    apellido,
                    correo,
                    password,
                    sedes,
                    nombre
                }
            });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ createAdministrator: error });
        }
    };

    getAdministrators = async (page, limit) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/administrators`;
            if (page && limit) {
                destination = `${this.baseURL}/${centroId}/administrators?page=${page}&limit=${limit}`;
            }
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getAdministrators: error });
        }
    };

    getAllAdministrators = async (search) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/administrators?search=${search}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getAllAdministrators: error });
        }
    };

    manageSedeToAdmin = async (sede, idadminTarget, action) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/administrators/${idadminTarget}/actions/sede`;
            const method = action === 1 ? 'POST' : 'DELETE';
            const connection = await axios({ method, url: destination, headers: this.headers, data: { sedeid: sede } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ manageSedeToAdmin: error });
        }
    };

    requestPasswordReset = async uidadminTarget => {
        try {
            const destination = `${this.authURL}/usuarios/${uidadminTarget}/actions/recovery`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ requestPasswordReset: error });
        }
    };

    manageAdminStatus = async (idadmintarget, status) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/administrators/${idadmintarget}`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { status } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ manageAdminStatus: error });
        }
    };

    deleteAdministrator = async idadmintarget => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/administrators/${idadmintarget}`;
            const connection = await axios({ method: 'DELETE', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ deleteAdministrator: error });
        }
    };

    getSedes = async (select, page, limit, signal) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/sedes`;
            if (select) {
                destination = `${this.baseURL}/${centroId}/sedes?page=1&limit=1000`;
            }
            if (page && limit) {
                destination = `${this.baseURL}/${centroId}/sedes?page=${page}&limit=${limit}`;
            }
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, cancelToken: signal });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getSedes: error });
            return { cod: 'canceled' };
        }
    };

    getSedeData = async sedeId => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getSedeData: error });
        }
    };

    createSede = async ({ nombre, idciudad, telefono, correo, logoSede, descripcion, servicios, direccion, latitud, longitud }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: { nombre, idciudad, telefono, correo, logoSede, descripcion, servicios, direccion, latitud, longitud } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ createSede: error });
        }
    };

    updateSede = async ({ nombre, idciudad, telefono, correo, logoSede, descripcion, servicios, direccion, latitud, longitud, sedeid }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeid}`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { nombre, idciudad, telefono, correo, logoSede, descripcion, servicios, direccion, latitud, longitud } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ updateSede: error });
        }
    };

    createFacturacion = async ({ iddocumentoventa, idsistemacontable, prefijo, consecutivo, razonsocial, nit, telefono, direccion, pagaiva, idsede, informacionadicional }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/facturas`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: { iddocumentoventa, idsistemacontable, prefijo, consecutivo, razonsocial, nit, telefono, direccion, pagaiva, informacionadicional } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ createFacturacion: error });
        }
    };

    updateFacturacion = async ({ iddocumentoventa, idsistemacontable, prefijo, consecutivo, razonsocial, nit, telefono, direccion, pagaiva, idsede, iddatofactura, informacionadicional }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/facturas/${iddatofactura}`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { iddocumentoventa, idsistemacontable, prefijo, consecutivo, razonsocial, nit, telefono, direccion, pagaiva, informacionadicional } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ updateFacturacion: error });
        }
    };

    getFacturacionData = async (sedeId, facturacionId) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeId}/facturas/${facturacionId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    // message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getFacturacionData: error });
        }
    };

    disableSede = async sedeId => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeId}`;
            const connection = await axios({ method: 'DELETE', url: destination, headers: this.headers, data: { estado: false } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ disableSede: error });
        }
    };

    getServicios = async () => {
        try {
            const destination = `${this.utilitiesURL}/servicios`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getServicios: error });
        }
    };

    getSedeFields = async (sedeId, select, page, limit) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/canchas?sede=${sedeId}`;
            if (select) {
                destination = `${this.baseURL}/${centroId}/canchas?sede=${sedeId}&page=1&limit=1000`;
            }
            if (page && limit) {
                destination = `${this.baseURL}/${centroId}/canchas?sede=${sedeId}&page=${page}&limit=${limit}`;
            }
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    // message.info({ content: respuesta });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getSedeFields: error });
        }
    };

    getAllCanchas = async (sedeId, search) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas?sede=${sedeId}&search=${search}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getSedeFields: error });
        }
    };

    getSedeTarifas = async sedeId => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeId}/tarifas`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getSedeTarifas: error });
        }
    };

    getSedeTarifa = async (sedeId, tarifaId) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeId}/tarifas/${tarifaId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getSedeTarifa: error });
        }
    };

    createSedeTarifa = async ({ nombre, descripcion, dataTarifa, idsede }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/tarifas`;
            const connection = await axios({
                method: 'POST',
                url: destination,
                headers: this.headers,
                data: {
                    nombre,
                    descripcion,
                    dataTarifa
                }
            });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                case 1001:
                    message.info({ content: 'La panilla de precios no se pudo guardar porque no hay horarios registrados' });
                    return { cod };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ createSedeTarifa: error });
        }
    };

    updateSedeTarifa = async ({ nombre, descripcion, dataTarifa, idsede, tarifaid }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/tarifas/${tarifaid}`;
            const connection = await axios({
                method: 'PATCH',
                url: destination,
                headers: this.headers,
                data: {
                    nombre,
                    descripcion,
                    dataTarifa
                }
            });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                case 1001:
                    message.info({ content: 'La panilla de precios no se pudo actualizar porque no hay horarios registrados' });
                    return { cod };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ updateSedeTarifa: error });
        }
    };

    /** Métodos para pasaporte deportivo */
    getPasaportes = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/pasaportes`;
            //    message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta, key: 'process' });
                    return { cod };
                default:
                    //            message.success({ content: respuesta, key: 'process', duration: 2 });
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getPasaportes: error });
        }
    };

    downloadPasaportes = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/pasaportes/actions/download`;
            message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, responseType: 'blob' });
            const {
                data,
                data: { type }
            } = connection;
            //    console.log({ connection });
            switch (type) {
                case 'application/json':
                    message.info({ content: 'No hay registros por descargar', key: 'process' });
                    return;
                default:
                    message.success({ content: '¡Documento creado!', key: 'process', duration: 2 });
                    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', `Reporte-covid-19_${new Date()}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return;
            }
        } catch (error) {
            console.log({ downloadPasaportes: error });
        }
    };

    setPasaporte = async dataRegistro => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/pasaportes`;
            message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({
                method: 'POST',
                url: destination,
                headers: this.headers,
                data: {
                    dataRegistro
                }
            });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1002:
                    message.info({ content: respuesta, key: 'process' });
                    return { cod };
                default:
                    message.success({ content: respuesta, key: 'process', duration: 2 });
                    return { cod, data };
            }
        } catch (error) {
            console.log({ setPasaporte: error });
        }
    };

    getDeportes = async idtipoactividad => {
        try {
            const destination = idtipoactividad ? `${this.utilitiesURL}/deportes?idtipoactividad=${idtipoactividad}` : `${this.utilitiesURL}/deportes`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getDeportes: error });
        }
    };
    getClasificacion = async deporteId => {
        try {
            const destination = `${this.utilitiesURL}/deportes/${deporteId}/clasificacion`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getClasificacion: error });
        }
    };
    getAtributos = async () => {
        try {
            const destination = `${this.utilitiesURL}/atributos`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getAtributos: error });
        }
    };

    getTiposActividad = async () => {
        try {
            const destination = `${this.utilitiesURL}/tipoactividad`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getTiposActividad: error });
        }
    };

    getActividadesByTipo = async tipoActividad => {
        try {
            if (tipoActividad === undefined || tipoActividad === null || tipoActividad === '') {
                return { cod: 1000, data: [] };
            }

            if (typeof tipoActividad === 'number' || /^[0-9]+$/.test(`${tipoActividad}`)) {
                return this.getDeportes(tipoActividad);
            }

            const tiposActividadResponse = await this.getTiposActividad();
            if (tiposActividadResponse?.cod !== 1000) {
                return { cod: tiposActividadResponse?.cod || 500, data: [] };
            }

            const normalizedTipoActividad = `${tipoActividad}`.trim().toLowerCase();
            const tipoActividadRecord = tiposActividadResponse.data.find(activityType => {
                const activityName = activityType?.nombre ? activityType.nombre.trim().toLowerCase() : '';
                return activityName === normalizedTipoActividad || activityName?.includes(normalizedTipoActividad);
            });

            if (!tipoActividadRecord?.idtipoactividad) {
                return { cod: 1000, data: [] };
            }

            return this.getDeportes(tipoActividadRecord.idtipoactividad);
        } catch (error) {
            console.log({ getActividadesByTipo: error });
            return { cod: error?.response?.data?.cod || 500, data: [] };
        }
    };

    createClase = async payload => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/clases`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: payload });
            const {
                data: { data, cod, respuesta, mensaje }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default: {
                    const responseMessage = mensaje || respuesta || 'No fue posible crear la clase en este momento.';
                    return { cod, respuesta, mensaje: responseMessage };
                }
            }
        } catch (error) {
            console.log({ createClase: error });
            return {
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta,
                mensaje: error?.response?.data?.mensaje || error?.response?.data?.respuesta || 'No fue posible crear la clase en este momento.'
            };
        }
    };

    getClases = async ({ centroId = this.getCentroId(), start, end, page, limit, size, search } = {}) => {
        try {
            const queryParams = [];
            if (start !== undefined && start !== null && start !== '') {
                queryParams.push(`start=${start}`);
            }
            if (end !== undefined && end !== null && end !== '') {
                queryParams.push(`end=${end}`);
            }
            if (page !== undefined && page !== null && page !== '') {
                queryParams.push(`page=${page}`);
            }
            if (limit !== undefined && limit !== null && limit !== '') {
                queryParams.push(`limit=${limit}`);
            }
            if (size !== undefined && size !== null && size !== '') {
                queryParams.push(`size=${size}`);
            }
            if (search !== undefined && search !== null && search !== '') {
                queryParams.push(`search=${encodeURIComponent(search)}`);
            }
            const destination = `${this.baseURL}/${centroId}/clases${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getClases: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

     getClasesPorFecha = async ({ centroId = this.getCentroId(), page, size, sortBy, sortOrder, search } = {}) => {
        try {
            const queryParams = [];
            if (page !== undefined && page !== null && page !== '') {
                queryParams.push(`page=${page}`);
            }
            if (size !== undefined && size !== null && size !== '') {
                queryParams.push(`size=${size}`);
            }
            if (sortBy !== undefined && sortBy !== null && sortBy !== '') {
                queryParams.push(`sortBy=${sortBy}`);
            }
            if (sortOrder !== undefined && sortOrder !== null && sortOrder !== '') {
                queryParams.push(`sortOrder=${sortOrder}`);
            }
            if (search !== undefined && search !== null && search !== '') {
                queryParams.push(`search=${encodeURIComponent(search)}`);
            }
            const destination = `${this.baseURL}/${centroId}/clases-por-fecha${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getClasesPorFecha: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

    
    getClasesBySede = async ({ sedeId, start, end }) => {
        try {
            const centroId = this.getCentroId();
            const queryParams = [];
            if (start !== undefined && start !== null && start !== '') {
                queryParams.push(`start=${start}`);
            }
            if (end !== undefined && end !== null && end !== '') {
                queryParams.push(`end=${end}`);
            }
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeId}/clases${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getClasesBySede: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

    getClaseById = async classId => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/clases/${classId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getClaseById: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

    getClaseSesiones = async ({ classId, page, size, fecha, search, sortBy, sortOrder }) => {
        try {
            const centroId = this.getCentroId();
            const queryParams = [];
            if (page !== undefined && page !== null && page !== '') {
                queryParams.push(`page=${page}`);
            }
            if (size !== undefined && size !== null && size !== '') {
                queryParams.push(`size=${size}`);
            }
            if (fecha !== undefined && fecha !== null && fecha !== '') {
                queryParams.push(`fecha=${fecha}`);
            }
            if (search !== undefined && search !== null && search !== '') {
                queryParams.push(`search=${encodeURIComponent(search)}`);
            }
            if (sortBy !== undefined && sortBy !== null && sortBy !== '') {
                queryParams.push(`sortBy=${sortBy}`);
            }
            if (sortOrder !== undefined && sortOrder !== null && sortOrder !== '') {
                queryParams.push(`sortOrder=${sortOrder}`);
            }
            const destination = `${this.baseURL}/${centroId}/clases/${classId}/sesiones${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
            const connection = await axios({
                method: 'GET',
                url: destination,
                headers: this.headers
            });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    return { cod, data: { sesiones: [] } };
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getClaseSesiones: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

    updateClase = async (classId, payload) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/clases/${classId}`;
            const connection = await axios({ method: 'PUT', url: destination, headers: this.headers, data: payload });
            const {
                data: { data, cod, respuesta, mensaje }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default: {
                    const responseMessage = mensaje || respuesta || 'No fue posible actualizar la clase en este momento.';
                    return { cod, respuesta, mensaje: responseMessage };
                }
            }
        } catch (error) {
            console.log({ updateClase: error });
            return {
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta,
                mensaje: error?.response?.data?.mensaje || error?.response?.data?.respuesta || 'No fue posible actualizar la clase en este momento.'
            };
        }
    };

    deleteClase = async (classId, fecha) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/clases/${classId}`;
            if (fecha) {
                destination = `${destination}?fecha=${fecha}`;
            }
            const connection = await axios({ method: 'DELETE', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta, mensaje }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod, respuesta, mensaje };
            }
        } catch (error) {
            console.log({ deleteClase: error });
            return { 
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta || error?.message,
                mensaje: error?.response?.data?.mensaje || error?.response?.data?.message
            };
        }
    };

    deleteSesion = async sessionId => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sesiones/${sessionId}`;
            const connection = await axios({ method: 'DELETE', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta, mensaje }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod, respuesta, mensaje };
            }
        } catch (error) {
            console.log({ deleteSesion: error });
            return { 
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta || error?.message,
                mensaje: error?.response?.data?.mensaje || error?.response?.data?.message
            };
        }
    };

    getHorariosOcupados = async ({ fecha, idsede, idcancha }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/clases/horarios-ocupados?fecha=${fecha}&idsede=${idsede}&idcancha=${idcancha}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getHorariosOcupados: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

    createCancha = async ({ nombre, idclasificacion, imagenes, atributos, idsede }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas?sede=${idsede}`;
            const connection = await axios({
                method: 'POST',
                url: destination,
                headers: this.headers,
                data: { nombre, idclasificacion: idclasificacion || null, imagenes, atributos }
            });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ createCancha: error });
            return {
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta || 'No fue posible crear la zona en este momento.'
            };
        }
    };
    updateCancha = async ({ nombre, idclasificacion, imagenes, atributos, idsede, canchaId }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}?idsede=${idsede}`;
            const connection = await axios({
                method: 'PATCH',
                url: destination,
                headers: this.headers,
                data: { nombre, idclasificacion: idclasificacion || null, imagenes, atributos }
            });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ updateCancha: error });
            return {
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta || 'No fue posible actualizar la zona en este momento.'
            };
        }
    };
    getCanchaById = async canchaId => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getCanchaById: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };
    deleteCancha = async ({ canchaId, idsede }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}?idsede=${idsede}`;
            const connection = await axios({ method: 'DELETE', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ deleteCancha: error });
            return {
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta || 'No fue posible eliminar la zona en este momento.'
            };
        }
    };
    updateCanchaStatus = async ({ canchaId, estado }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}/actions/status`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { estado } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ updateCanchaStatus: error });
            return {
                cod: error?.response?.data?.cod || 500,
                respuesta: error?.response?.data?.respuesta || 'No fue posible actualizar el estado de la zona en este momento.'
            };
        }
    };
    addTarifaCancha = async ({ canchaId, tarifa, sede }) => {
        // console.log({ canchaId, tarifa, sede }, 'addTarifaCancha');
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}/actions/tarifa?sede=${sede}&tarifa=${tarifa}`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: {} });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ addTarifaCancha: error });
        }
    };

    getUsuarioDocument = async (documento, tipo) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/usuarios?documento=${documento}&tipo=${tipo}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getUsuarioDocument: error });
        }
    };

    getSesionUsuarios = async ({ sessionId, page, size, search, sortBy, sortOrder }) => {
        try {
            const centroId = this.getCentroId();
            const queryParams = [];
            if (page !== undefined && page !== null && page !== '') {
                queryParams.push(`page=${page}`);
            }
            if (size !== undefined && size !== null && size !== '') {
                queryParams.push(`size=${size}`);
            }
            if (search !== undefined && search !== null && search !== '') {
                queryParams.push(`search=${encodeURIComponent(search)}`);
            }
            if (sortBy !== undefined && sortBy !== null && sortBy !== '') {
                queryParams.push(`sortBy=${sortBy}`);
            }
            if (sortOrder !== undefined && sortOrder !== null && sortOrder !== '') {
                queryParams.push(`sortOrder=${sortOrder}`);
            }
            const destination = `${this.baseURL}/${centroId}/sesiones/${sessionId}/usuarios${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    return { cod, data: [] };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getSesionUsuarios: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

    createSesionUsuario = async (sessionId, payload) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sesiones/${sessionId}/usuarios`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: payload });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ createSesionUsuario: error });
            return { cod: error?.response?.data?.cod || 500 };
        }
    };

    deleteSesionUsuario = async (sessionId, idrsvp) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sesiones/${sessionId}/rsvp/${idrsvp}`;
            const connection = await axios({ method: 'DELETE', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod, respuesta };
            }
        } catch (error) {
            console.log({ deleteSesionUsuario: error });
            return { cod: error?.response?.data?.cod || 500, respuesta: error?.response?.data?.respuesta || error?.message };
        }
    };


    checkDisponibilidadReserva = async ({ canchaId, sedeId, start, end, rsvId }) => {
        try {
            const centroId = this.getCentroId();
            // http://localhost:8080/centros/16/canchas/2/actions/rsvp?sede=11&datetimestart=1600794000&datetimeend=1600797600
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}/actions/rsvp?sede=${sedeId}&datetimestart=${start}&datetimeend=${end}${rsvId ? `&historicorsvpId=${rsvId}` : ''}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ checkDisponibilidadReserva: error });
        }
    };

    getTarifaHoras = async (canchaId, sedeId, selected, timepicker) => {
        try {
            const centroId = this.getCentroId();
            // http://localhost:8080/centros/16/canchas/2/actions/tarifa?sede=11&fecha=2020-03-23&hora=06
            const fecha = moment(selected[0]).format('YYYY-MM-DD');
            if (timepicker) {
                const horainicio = moment(selected[0]);
                const horafinal = moment(selected[1]);
                // Generar intervalos de 30 minutos
                const horasbuscar = [];
                const current = moment(horainicio);

                while (current.isBefore(horafinal)) {
                    horasbuscar.push(current.format('HH:mm'));
                    current.add(30, 'minutes');
                }
                const requestList = horasbuscar.map(hora => {
                    const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}/actions/tarifa?sede=${sedeId}&fecha=${fecha}&hora=${hora}`;
                    return axios({ method: 'GET', url: destination, headers: this.headers });
                });

                const connection = await Promise.all(requestList);
                const tarifa = connection
                    .filter(respuesta => respuesta.data.cod === 1000)
                    .reduce((total, actual) => {
                        const monto = parseFloat(actual.data.data[0].monto, 10);
                        return monto + total;
                    }, 0);

                return tarifa;
            }
            if (selected.length > 2) {
                const requestList = selected.slice(0, selected.length - 1).map(datetime => {
                    const hora = moment(datetime).format('HH:mm');
                    const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}/actions/tarifa?sede=${sedeId}&fecha=${fecha}&hora=${hora}`;
                    return axios({ method: 'GET', url: destination, headers: this.headers });
                });
                const connection = await Promise.all(requestList);
                const tarifa = connection
                    .filter(respuesta => respuesta.data.cod === 1000)
                    .reduce((total, actual) => {
                        const monto = parseFloat(actual.data.data[0].monto, 10);
                        return monto + total;
                    }, 0);
                return tarifa;
            }
            const hora = moment(selected[0]).format('HH:mm');
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}/actions/tarifa?sede=${sedeId}&fecha=${fecha}&hora=${hora}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });

            const tarifa = [{ ...connection }]
                .filter(respuesta => respuesta.data.cod === 1000)
                .reduce((total, actual) => {
                    const monto = parseFloat(actual.data.data[0].monto, 10);
                    //               console.log({ monto });
                    return monto + total;
                }, 0);
            return tarifa;
        } catch (error) {
            console.log({ getTarifaHoras: error });
        }
    };

    getReservasOnRange = async (canchaId, sedeId, start, end) => {
        try {
            const centroId = this.getCentroId();
            // http://localhost:8080/centros/16/canchas/2/rsvp?sede=11&start=1600664400&end=1601182800
            const destination = `${this.baseURL}/${centroId}/canchas/${canchaId}/rsvp?sede=${sedeId}&start=${start}&end=${end}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getReservasOnRange: error });
        }
    };

    createUser = async ({ nombre, apellido, correo, telefono, tipodocumento, numerodocumento, direccion }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/usuarios`;
            const payload = { nombre, apellido, telefono, tipodocumento, numerodocumento };
            if (correo && correo.trim()) payload.correo = correo.trim();
            if (direccion && direccion.trim()) payload.direccion = direccion.trim();
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: payload });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ createUser: error });
        }
    };

    updateUser = async ({ nombre, apellido, correo, telefono, tipodocumento, numerodocumento, direccion, idusuario }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/usuarios/${idusuario}`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { nombre, apellido, correo, telefono, tipodocumento, numerodocumento, direccion } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ updateUser: error });
        }
    };

    getAllUsers = async (select, page, limit) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/usuarios`;
            if (select) {
                destination = `${this.baseURL}/${centroId}/usuarios?page=1&limit=1000`;
            }
            if (page && limit) {
                destination = `${this.baseURL}/${centroId}/usuarios?page=${page}&limit=${limit}`;
            }
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta, key: 'process' });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getAllUsers: error });
        }
    };

    getAllUsersName = async (search) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/usuarios?search=${search}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta, key: 'process' });
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getAllUsersName: error });
        }
    };

    createBooking = async ({ idcancha, idsede, timestamprsvp, timestamprsvpend, handlerepeat, repetir, facturar, idusuario, tarifa }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${idcancha}/rsvp?sede=${idsede}`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: { timestamprsvp, timestamprsvpend, handlerepeat, repetir, facturar, idusuario, tarifa } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ createBooking: error });
        }
    };

    updateBooking = async ({ timestamprsvp, timestamprsvpend, idusuario, tarifa, idcancha, idrsvp, idsede, moveToField, comments }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${idcancha}/rsvp/${idrsvp}?sede=${idsede}`;
            const connection = await axios({ method: 'PATCH', url: destination, headers: this.headers, data: { timestamprsvp, timestamprsvpend, idusuario, tarifa, moveToField, comments } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ updateBooking: error });
        }
    };

    cancelBooking = async (idcancha, idsede, idrsvp) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${idcancha}/rsvp/${idrsvp}?sede=${idsede}`;
            const connection = await axios({ method: 'DELETE', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ cancelBooking: error });
        }
    };

    setRsvpPayments = async ({ idcancha, idsede, idrsvp, payments, planName }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${idcancha}/rsvp/${idrsvp}/actions/payments?sede=${idsede}`;
            const payload = { payments, planName };
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: payload });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ setRsvpPayments: error });
        }
    };

    getRsvpPayments = async ({ idcancha, idsede, idrsvp, idusuario }) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/canchas/${idcancha}/rsvp/${idrsvp}/actions/payments?sede=${idsede}`;
            if (idusuario !== undefined && idusuario !== null && idusuario !== '') {
                destination += `&idusuario=${idusuario}`;
            }
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ getRsvpPayments: error });
        }
    };

    getReservasOnRangeSede = async (sedeId, start, end) => {
        try {
            const centroId = this.getCentroId();
            // http://localhost:8080/centros/16/sedes/11/rsvp?start=1600664400&end=1601182800
            const destination = `${this.baseURL}/${centroId}/sedes/${sedeId}/rsvp?start=${start}&end=${end}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    return { cod };
                default:
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getReservasOnRangeSede: error });
        }
    };

    manageFieldNesting = async ({ idcancha, idsede, nestedfields }) => {
        // http://localhost:8080/centros/16/canchas/2/actions/nest?sede=1
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/canchas/${idcancha}/actions/nest?sede=${idsede}`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: { nestedfields } });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ manageFieldNesting: error });
        }
    };

    /** Módulo de reportes */
    getReportDataForDisplay = async ({ idsede, start, end, idtipoactividad, signal }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/reports?start=${start}&end=${end}${idtipoactividad ? `&idtipoactividad=${idtipoactividad}` : ''}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, cancelToken: signal });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    return { cod };
            }
        } catch (error) {
            console.log({ getReportDataForDisplay: error });
            return { cod: 'canceled' };
        }
    };

    downloadReportPlayedRsvp = async ({ idsede, start, end, idtipoactividad, signal }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/reports/actions/download/playedrsvp?start=${start}&end=${end}${idtipoactividad ? `&idtipoactividad=${idtipoactividad}` : ''}`;
            message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, responseType: 'blob', cancelToken: signal });
            const {
                data,
                data: { type }
            } = connection;
            //    console.log({ connection });
            switch (type) {
                case 'application/json':
                    message.info({ content: 'No hay registros por descargar', key: 'process' });
                    return;
                default:
                    message.success({ content: '¡Documento creado!', key: 'process', duration: 2 });
                    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', `Played_rsvp${new Date()}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return;
            }
        } catch (error) {
            console.log({ downloadReportPlayedRsvp: error });
            return { cod: 'canceled' };
        }
    };

    downloadReportCreatedRsvp = async ({ idsede, start, end, idtipoactividad, signal }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/reports/actions/download/createdrsvp?start=${start}&end=${end}${idtipoactividad ? `&idtipoactividad=${idtipoactividad}` : ''}`;
            message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, responseType: 'blob', cancelToken: signal });
            const {
                data,
                data: { type }
            } = connection;
            //    console.log({ connection });
            switch (type) {
                case 'application/json':
                    message.info({ content: 'No hay registros por descargar', key: 'process' });
                    return;
                default:
                    message.success({ content: '¡Documento creado!', key: 'process', duration: 2 });
                    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', `Created_rsvp${new Date()}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return;
            }
        } catch (error) {
            console.log({ downloadReportCreatedRsvp: error });
            return { cod: 'canceled' };
        }
    };

    downloadReportCanceledRsvp = async ({ idsede, start, end, idtipoactividad, signal }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/reports/actions/download/canceledrsvp?start=${start}&end=${end}${idtipoactividad ? `&idtipoactividad=${idtipoactividad}` : ''}`;
            message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, responseType: 'blob', cancelToken: signal });
            const {
                data,
                data: { type }
            } = connection;
            //    console.log({ connection });
            switch (type) {
                case 'application/json':
                    message.info({ content: 'No hay registros por descargar', key: 'process' });
                    return;
                default:
                    message.success({ content: '¡Documento creado!', key: 'process', duration: 2 });
                    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', `Canceled_rsvp${new Date()}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return;
            }
        } catch (error) {
            console.log({ downloadReportCanceledRsvp: error });
            return { cod: 'canceled' };
        }
    };

    downloadReportPayments = async ({ idsede, start, end, idtipoactividad, signal }) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/sedes/${idsede}/reports/actions/download/payments?start=${start}&end=${end}${idtipoactividad ? `&idtipoactividad=${idtipoactividad}` : ''}`;
            message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, responseType: 'blob', cancelToken: signal });
            const {
                data,
                data: { type }
            } = connection;
            //    console.log({ connection });
            switch (type) {
                case 'application/json':
                    message.info({ content: 'No hay registros por descargar', key: 'process' });
                    return;
                default:
                    message.success({ content: '¡Documento creado!', key: 'process', duration: 2 });
                    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', `Payments${new Date()}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return;
            }
        } catch (error) {
            console.log({ downloadReportPayments: error });
            return { cod: 'canceled' };
        }
    };

    getCountries = async () => {
        try {
            const destination = `${this.utilitiesURL}/paises`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getCountries: error });
        }
    };

    getCities = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.utilitiesURL}/ciudades?centro=${centroId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getCities: error });
        }
    };

    getDocuments = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.utilitiesURL}/documentos?centro=${centroId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getDocuments: error });
        }
    };

    getPaymethods = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.utilitiesURL}/paymethods?centro=${centroId}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getDocuments: error });
        }
    };

    getPaymentsLog = async (sedeid, dateselected) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/logs/payments?sedeid=${sedeid}&dateselected=${dateselected}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getPaymentsLog: error });
        }
    };

    getRsvpLog = async (sedeid, dateselected) => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/logs/rsvp?sedeid=${sedeid}&dateselected=${dateselected}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getRsvpLog: error });
        }
    };

    /* obtener tipo de documento de venta */
    getDocumentsVenta = async () => {
        try {
            const destination = `${this.utilitiesURL}/documentosventas`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getDocumentsVenta: error });
        }
    };

    /* obtener tipo de sistema contable */
    getSistemaContable = async idpagodetalle => {
        try {
            const destination = `${this.utilitiesURL}/sistemacontable`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getSistemaContable: error });
        }
    };
    /* Obtener datos para la factura */
    getInfofactura = async idpagodetalle => {
        try {
            const destination = `${this.utilitiesURL}/infopdf/${idpagodetalle}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getInfofactura: error });
        }
    };

    getAllComprobantesIC = async () => {
        try {
            // Se prueba con el ID 46
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/ic-invoices/`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getAllComprobantesIC: error });
        }
    };

    downloadXLSIC = async idfacturasede => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/ic-invoices/${idfacturasede}/xls`;
            message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers, responseType: 'blob' });
            const {
                data,
                data: { type }
            } = connection;
            switch (type) {
                case 'application/json':
                    message.info({ content: 'No hay registros por descargar', key: 'process' });
                    return;
                default:
                    message.success({ content: '¡Documento creado!', key: 'process', duration: 2 });
                    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', `WeeklyReport${new Date()}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return;
            }
        } catch (error) {
            console.log({ downloadXLSIC: error });
            return { cod: 'canceled' };
        }
    };

    downloadPDFIC = async idfacturasede => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/ic-invoices/${idfacturasede}/pdf`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getAllComprobantesIC: error });
        }
    };

    getInfPagosSede = async (sedeid, search, { start, end }) => {
        try {
            const centroId = this.getCentroId();
            let destination = `${this.baseURL}/${centroId}/infPaymentsSede?sedeid=${sedeid}&start=${start}&end=${end}`;
            if (search) {
                destination = `${this.baseURL}/${centroId}/infPaymentsSede?sedeid=${sedeid}&search=${search}`;
            }
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getInfPagosSede: error });
        }
    };

    /*
    getPasaportes = async () => {
        try {
            const centroId = this.getCentroId();
            const destination = `${this.baseURL}/${centroId}/pasaportes`;
            //    message.loading({ content: 'Cargando información...', key: 'process' });
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1003:
                    message.info({ content: respuesta, key: 'process' });
                    return { cod };
                default:
                    //            message.success({ content: respuesta, key: 'process', duration: 2 });
                    return { cod, data };
            }
        } catch (error) {
            console.log({ getPasaportes: error });
        }
    };
    */

    /**
     * Obtiene las reservas de un usuario en un centro específico.
     *
     * @async
     * @param {number|string} centerId - ID del centro.
     * @param {number|string} userId - ID del usuario.
     * @param {Object} filters - Parámetros de consulta.
     * @param {number} [filters.page] - Página actual.
     * @param {number} [filters.limit] - Cantidad de registros por página.
     * @param {string} [filters.from] - Fecha inicial (ISO).
     * @param {string} [filters.to] - Fecha final (ISO).
     * @param {string[]} [filters.statuses] - Estados de la reserva.
     *
     * @returns {Promise<{
     *   cod: number,
     *   data?: {
     *     reservations: Array<{
     *       id: number,
     *       hour: string,
     *       status: string,
     *       username: string,
     *       fieldname: string,
     *       startreservation: string,
     *       endreservation: string,
     *       modifiedby: string
     *     }>,
     *     pageInfo: {
     *       limit: number,
     *       offset: number,
     *       total: number,
     *       pages: number
     *     }
     *   }
     * }>}
     * Retorna las reservas del usuario cuando `cod` es 1000.
     */

    getReservationsByUser = async (userId, filters) => {
        try {
            // const { page = 1, limit = 10, from, to, field, statuses } = filters
            const centerId = this.getCentroId();
            const params = buildQueryParams(filters);
            const destination = `${this.baseURL}/${centerId}/usuarios/${userId}/reservaciones?${params}`;
            const connection = await axios({ method: 'GET', url: destination, headers: this.headers });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ getReservationsByUse: error });
        }
    };

    allCheckCancelReservationsUsers = async (userId, body = { all: false, ids: [] }) => {
        try {
            // const { page = 1, limit = 10, from, to, field, statuses } = filters
            const centerId = this.getCentroId();
            const destination = `${this.baseURL}/${centerId}/usuarios/${userId}/reservaciones/cancelar`;
            const connection = await axios({ method: 'POST', url: destination, headers: this.headers, data: body });
            const {
                data: { data, cod, respuesta }
            } = connection;
            switch (cod) {
                case 1000:
                    return { cod, data };
                default:
                    message.info({ content: respuesta });
                    return { cod };
            }
        } catch (error) {
            console.log({ allCheckCancelReservationsUsers: error });
        }
    };
}

export default Backend;
